import { Injectable } from "@angular/core";
import { PagePermissionType } from "app/models/page-permission-type";
import { Url_Base } from "app/rest-constants";
import { Page } from "./page-permission.service";
import { RestService } from "./rest-service";

 
 @Injectable()
 export class UserPagePermission {
     cachedPagePermissions: any;
 
   constructor(
     private mRestService: RestService,
   ) { }

    /**
   * Pages available in the Web Application. (Dynamically retrive this from backend)
   */
  public getListOfAccessiblePages(): Promise < Page[] > {
    const url = `${Url_Base}/user-permissions`;

      return this.mRestService.get<UserPageAccess[]>(url).then((permissions) => {
          return permissions
              // Filter accessible pages
              .filter((perm) => perm.isAccessible)
              // Map to Page objects
              .map((perm) => ({
                  permissionType: perm.pageName as PagePermissionType,
                  label: this.getPageLabel(perm.pageName as PagePermissionType),
              })); 
      });
  }

  private getPageLabel(permissionType: PagePermissionType): string {
    const pagePermission = this.cachedPagePermissions?.get(permissionType);
    return pagePermission?.formattedName || 'Unknown Page';
}


}


export interface UserPageAccess {
    pageId: number;
    pageName: string;
    isAccessible: boolean;
}


